import { format } from 'date-fns';
import { TIME_FORMAT_WITH_SECONDS } from '@dealroadshow/uikit-date-time/dateFormats';
import { DayPart, TIME_INPUT_TYPES_VALUES, TimeInputTypes } from './TimePicker/constants';

export const takeDayTime = (value) => {
  const date = format(new Date(value), TIME_FORMAT_WITH_SECONDS);
  const [timeValues, dayPart] = date.split(' ');
  const [hours, minutes, seconds] = timeValues.split(':');

  const hoursCount = (Number(hours) === 12) && dayPart === DayPart.AM ? 0 : hours;

  let time = Number(hoursCount) * TIME_INPUT_TYPES_VALUES[TimeInputTypes.HOURS]
      + Number(minutes) * TIME_INPUT_TYPES_VALUES[TimeInputTypes.MINUTES]
      + Number(seconds);

  if (dayPart === DayPart.PM) {
    time += TIME_INPUT_TYPES_VALUES[DayPart.PM];
  }

  return time;
};
